// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","download":"_3zwUy3lSSbCZ","logo":"_3DzJLXWlH4q-","downloadIcon":"SWODhDjUJpCT","button":"_3cKzsp1Dh05L"};